export const ControlRoutes = {
  Login: '',
  Documents: 'documents',
  WhatsNew: 'whats-new'
};
